import type {
  FaceData,
  OpticalMeasureFramingDistanceProfileSettings,
} from '../index'
import { PdSample } from './types'
import { averagePd, pdVariance } from './utils'
import { useStableMeasurement } from './useStableMeasurement'

export function usePdMeasurement(
  distanceProfile: OpticalMeasureFramingDistanceProfileSettings
) {
  return useStableMeasurement<PdSample, PdSample>({
    distanceProfile,
    extractSample: (incoming: FaceData) => {
      if (incoming.nearPd == null || incoming.nearLeftPd == null || incoming.nearRightPd == null) {
        return null
      }
      return {
        pd: incoming.pd,
        leftPd: incoming.leftPd,
        rightPd: incoming.rightPd,
        nearPd: incoming.nearPd,
        nearLeftPd: incoming.nearLeftPd,
        nearRightPd: incoming.nearRightPd,
      }
    },
    variance: (samples) => pdVariance(samples.map((sample) => sample.pd)),
    average: averagePd,
    bufferSize: 5,
    stableForMs: 500,
    sampleDurationMs: 500,
  })
}
